/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Core
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

// Components
import InputDefault from "components/InputFields/InputDefault";
import { Box, Typography, Card, List, ListItem } from "@mui/material";

function IndexedSimplified({ data, onChange, action }) {
  const { t } = useTranslation(["contracts"]);

  return (
    <Box>
      <Card sx={{ p: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, marginLeft: 2 }}>
          <Box sx={{ maxWidth: 100 }}>
            <InputDefault
              disabled={action === "view"}
              type="number"
              size="small"
              label="A"
              defaultValue={data?.multiplierPMD ?? 0}
              onChange={(e) => onChange("multiplierPMD", e.target.value)}
              inputProps={{ step: "any" }}
            />
          </Box>
          <Box sx={{ maxWidth: 100 }}>
            <InputDefault
              disabled={action === "view"}
              type="number"
              size="small"
              label="B"
              defaultValue={data?.multiplierERSE ?? 0}
              onChange={(e) => onChange("multiplierERSE", e.target.value)}
              inputProps={{ step: "any" }}
            />
          </Box>
          <Box sx={{ maxWidth: 100 }}>
            <InputDefault
              disabled={action === "view"}
              type="number"
              size="small"
              label="C"
              defaultValue={data?.additiveC ?? 0}
              onChange={(e) => onChange("additiveC", e.target.value)}
              inputProps={{ step: "any" }}
            />
          </Box>
        </Box>
        <Typography variant="h6">{t("single.indexed_simple.formula_title")}</Typography>
        <Typography variant="caption" sx={{ mb: 2, whiteSpace: "pre-line" }}>
          {t("single.indexed_simple.formula_inline")}
          <List sx={{ marginTop: 4 }}>
            <ListItem>
              <Typography variant="caption">{t("single.indexed_simple.bullets.A")}</Typography>
            </ListItem>
            <ListItem>
              <Typography variant="caption">{t("single.indexed_simple.bullets.B")}</Typography>
            </ListItem>
            <ListItem>
              <Typography variant="caption">{t("single.indexed_simple.bullets.C")}</Typography>
            </ListItem>
          </List>
        </Typography>
      </Card>
    </Box>
  );
}

IndexedSimplified.defaultProps = {
  onChange: null,
};

IndexedSimplified.propTypes = {
  data: PropTypes.shape({
    multiplierPMD: PropTypes.number,
    multiplierERSE: PropTypes.number,
    additiveC: PropTypes.number,
  }).isRequired,
  action: PropTypes.string.isRequired,
  onChange: PropTypes.func,
};

export default IndexedSimplified;
